export default () => ({
  clientWidth: 0,
  userIp: '',
  deviceType: 'pc',
  historyTags: [],
  subscribe: null
})
